import React from 'react'
import diagImg from "../assets/images/clinical.png"

const Select = ({ content, onSelected, defaultSelected }) => {
    let c = content;
    let onChange = (event) => {
        let ix = parseInt(event.target.value);
        let choice = c.choices[ix];
        onSelected(c.id, choice);
    }

    return (
        <div className="question">
            <div className="question-content">
                
                <h3 className={c.style + " selected"}>{c.title == "Clinical Situation" ? <img className="icon" style={{width:"18px", marginRight:"8px", marginLeft: "2px"}} src={diagImg}/> : null}{c.title}</h3>
                <p>{c.text}</p>
                <select className="form-control" id={c.id} onChange={onChange}> 
                    {c.choices.map((o, ix) => {
                        if(o.text == defaultSelected) {
                            return <option selected key={o.text} value={ix}>{o.text}</option>
                        } else {
                            return <option key={o.text} value={ix}>{o.text}</option>
                        }
                    })}
                </select>
            </div>
        </div>)
};

export default Select